document.addEventListener("DOMContentLoaded", function () {
  const mobileVideo = document.querySelector(".mobile-video video");
  // ✅ Mobile: Play video when in view
  if (mobileVideo) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && window.innerWidth <= 768) {
          mobileVideo.play();
        } else {
          mobileVideo.pause();
        }
      });
    }, { threshold: 0.5 });

    observer.observe(mobileVideo);
  }
  
  new ScrollyVideo({
      scrollyVideoContainer: "scrolly-video",
      src: window.videoUrl
    });
});
